import { useBreakpoints } from '#client/hooks/useBreakpoints';

import {
  Heading,
  MainContainer,
  MarkCubanImage,
  MarkCubanImageContainer,
  SubHeading,
  TextsContainer
} from './components';

const Header = () => {
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  const markCubanImage = (
    <MarkCubanImageContainer>
      <MarkCubanImage
        src="/journey%20to%20success/00%20dashboard/Cuban.png"
        alt="education studio dashboard image"
        width={500}
      />
    </MarkCubanImageContainer>
  );

  return (
    <MainContainer>
      <TextsContainer display="flex" flexDirection="column" alignItems="flex-start">
        <Heading variant="md-alt">
          Cuban-Approved
        </Heading>
        <Heading level={1} variant="hg">
          Small Business Learning
        </Heading>
        {isMobile && markCubanImage}
        <SubHeading size="lg">
          Get free resources and how-to videos with everything you need to know to start,
          run, and grow your small business or business-of-one.
        </SubHeading>
      </TextsContainer>
      {!isMobile && markCubanImage}
    </MainContainer>
  );
};

export default Header;
